import { Swiper } from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';

export const initPostCarousel = () => {
	const container = document.querySelector('.post-carousel');
	if (!container) return;

	const swiperEl = container.querySelector('.swiper');
	const pagination = container.querySelector('.post-carousel-pagination');

	if (!swiperEl) return;

	new Swiper(swiperEl, {
		modules: [Pagination],
		slidesPerView: 1,
		spaceBetween: 40,
		loop: false,
		grabCursor: true,
		pagination: {
			el: pagination,
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 60,
			},
			1024: {
				spaceBetween: 80,
			},
		},
	});
};
